import { ReleaseNote } from './types'

export const RELEASE_NOTES_CONTENTS: ReleaseNote[] = [
  {
    version: '2.0.0',
    releasedDate: '2024-01-10',
    features: [
      {
        title: 'Document Content Revision',
        contents: [
          'All pages of the document have been edited by compiling and rewriting to ensure the content is closely aligned with the current PDPA laws.',
        ],
      },
      {
        title: 'Guidance for Implementation',
        contents: [
          'It is recommended to review each new version of the document to make adjustments and plan operations in compliance with the current regulations of the PDPA law.',
        ],
      },
    ],
  },
  {
    version: '1.2.0',
    releasedDate: '2022-09-28',
    features: [
      {
        title: 'Update policy privacy on "วิธีการใช้สิทธิ" section',
      },
    ],
  },
  {
    version: '1.1.0',
    releasedDate: '2022-06-23',
    features: [
      {
        title: 'We add Release Note button on landing page',
      },
    ],
  },
  {
    version: '1.0.0',
    releasedDate: '2022-05-19',
    features: [
      {
        title: '2C2P',
        contents: [
          'We add a new payment gateway into the system so this platform can support both Stripe Payment and 2C2P Payment as well.',
          'Noted: 2C2P Payment is a default gateway.',
        ],
      },
      {
        title: 'Password complexity improvement',
        contents: [
          'Passwords must meet complexity requirements. Policy settings determine whether passwords must comply with strong password practices.',
          'A password guidelines must contain: At least 8 characters, Lowercase characters (a-z), Uppercase characters (A-Z), At least one number (0-9), At least one special character(-!$%@^&*#()_+|~=`[]:";\'<>?,./)',
          'We add password complexity in the register and change the password page for suggesting to users how to create a password.',
        ],
      },
    ],
  },
]
